import { Form, Stack } from 'react-bootstrap';
import CustomLeafletControl from './CustomLeafletControl';

const MapView = ({ satelliteView, labelsEnabled, onToggleSatellite, onToggleLabels, extra }) => {
  return (
    <CustomLeafletControl position="bottomleft">
      <Stack className="leaflet-bar bg-white p-2 pb-0 rounded-3">
        {extra}
        {satelliteView && (
          <Form.Check
            id="map-label-toggle"
            type="checkbox"
            className="text-dark"
            label={<span className="text-dark">Labels</span>}
            checked={labelsEnabled}
            onChange={onToggleLabels}
          />
        )}
        <Form.Check
          type="switch"
          id="map-satellite-toggle"
          label={<span className="text-dark">{satelliteView ? 'Satellite' : 'Map'}</span>}
          className="text-dark"
          checked={satelliteView}
          onChange={onToggleSatellite}
        />
      </Stack>
    </CustomLeafletControl>
  );
};

export default MapView;
